import { VideoStore } from '../video.store';
import { isInterstitialAdUnit } from '../../adUnit';
import { ConfigStore } from '../config.store';

export type ControlsStrategyType =
  | 'fullscreen'
  | 'mpu'
  | 'responsive'
  | 'hide'
  | 'endScreenCTA';

export const ControlsStrategyTypes = {
  FULLSCREEN: 'fullscreen' as const,
  MPU: 'mpu' as const,
  RESPONSIVE: 'responsive' as const,
  HIDE: 'hide' as const,
  END_SCREEN_CTA: 'endScreenCTA' as const
};

export interface ControlsStrategy {
  type: ControlsStrategyType;
  canExpand(): boolean;
  shouldDisplayProgressBar(): boolean;
  shouldDisplayVastIcon(): boolean;
  shouldHideOptout(): boolean;
  shouldDisplayOptOut(): boolean;
  shouldDisplayCloseButton(elapsedTime?: number): boolean;
  shouldHideCloseButton(): boolean;
  shouldDisableCloseButton(
    showRecommendation?: boolean,
    elapsedTime?: number
  ): boolean;
  shouldDisplayMuteButton(): boolean;
  shouldDisplayBrandItem(): boolean;
}

export class DefaultControlsStrategy implements ControlsStrategy {
  configStore: ConfigStore;
  adContext: Record<string, any> = {};
  videoStore: VideoStore;
  type!: ControlsStrategyType;

  constructor(
    videoStore: VideoStore,
    config: ConfigStore,
    adContext: Record<string, any>
  ) {
    this.videoStore = videoStore;
    this.configStore = config;
    this.adContext = adContext;
  }

  // TODO: The config key should be expand and hold a prop canExpand + isVisible ?
  canExpand(): boolean {
    return Boolean(
      this.configStore.config.expandButton &&
        this.configStore.config.expandButton.visible
    );
  }

  shouldDisplayProgressBar(): boolean {
    return (
      Boolean(this.configStore.config.controls?.showProgressBar) &&
      !this.videoStore.isVideoCompleted.value
    );
  }

  shouldDisplayVastIcon(): boolean {
    return Boolean(this.configStore.config.displayVastIcon);
  }

  shouldHideOptout(): boolean {
    return this.shouldDisplayVastIcon() && this.configStore.config.optOut.hide;
  }

  shouldDisplayOptOut(): boolean {
    return Boolean(
      (this.adContext.showOptoutLink && !this.shouldHideOptout()) ||
        this.adContext.childPrivacyApplied
    );
  }

  shouldDisplayCloseButton(elapsedTime?: number): boolean {
    return false;
  }

  shouldDisableCloseButton(
    showRecommendation?: boolean,
    elapsedTime?: number
  ): boolean {
    return false;
  }

  shouldHideCloseButton(): boolean {
    return (
      !isInterstitialAdUnit(this.adContext.adUnitType) &&
      Boolean(
        this.configStore.config.closeBtn &&
          this.configStore.config.closeBtn.hideOnOverlay
      )
    );
  }

  shouldDisplayMuteButton(): boolean {
    return Boolean(
      this.configStore.config.controls &&
        this.configStore.config.controls.sound &&
        this.configStore.config.controls.sound.enabled
    );
  }

  shouldDisplayBrandItem(): boolean {
    return Boolean(
      this.configStore.config.brandItem &&
        this.configStore.config.brandItem.show
    );
  }
}
